import ApiConstants from "../utils/apiConstants";
import { axios } from "../utils/axios";

const baseUrl = process.env.REACT_APP_API_HOST;

export const getAggregatorStatus = async () => {
  try {
    const response = await axios.get(`${baseUrl}/${ApiConstants.AGGREGATOR_STATUS}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRetailerDistributorInformation = async (id, type = "distributor") => {
  try {
    const response = await axios.get(`${baseUrl}/${ApiConstants.LOG_TRANSACTION_RETAILER_DISTRIBUTOR_INFO}/${id}/${type}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchUsers = async (inputValue) => {
  try {
    const response = await axios.get(`${baseUrl}/admin/search?query=${inputValue}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getUsers = async (filterData, page, size) => {
  try {
    let url = `${baseUrl}/${ApiConstants.ADMIN_USERS}?page=${page}&size=${size}`
    const queryParams = new URLSearchParams(filterData).toString();

    if (queryParams) {
      url += `&${queryParams}`;
    }

    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const addUser = async (userData) => {
  try {
    const response = await axios.post(`${baseUrl}/${ApiConstants.ADMIN_USERS}`, userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (id, userData) => {
  try {
    const response = await axios.put(`${baseUrl}/${ApiConstants.ADMIN_USERS}/${id}`, userData);
    return response;
  } catch (error) {
    throw error;
  }
};
